class CollectionTabs extends HTMLElement {
    constructor() {
        super();
        this.tabButtons = this.querySelectorAll('[data-tab-button]');
        this.tabContents = this.querySelectorAll('[data-tab-content]');

        this.init();
    }

    init() {
        // Set first tab as active by default
        this.setActiveTab(this.tabButtons[0]?.getAttribute('data-tab-button'));

        // Add click listeners to tabs
        this.tabButtons.forEach(button => {
            button.addEventListener('click', () => {
                const tabId = button.getAttribute('data-tab-button');
                this.setActiveTab(tabId);
            });
        });
    }

    setActiveTab(tabId) {
        console.log('Setting active tab:', tabId);
        // Update button states
        this.tabButtons.forEach(button => {
            const isActive = button.getAttribute('data-tab-button') === tabId;
            button.classList.toggle('active', isActive);
        });

        // Update content visibility
        this.tabContents.forEach(content => {
            content.classList.toggle('active',
                content.getAttribute('data-tab-content') === tabId
            );
        });
    }
}

customElements.define('collection-tabs', CollectionTabs);